import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

const TWITTER_WIDGETS_SRC = "https://platform.twitter.com/widgets.js"
const TWITTER_SCRIPT_ID = "twitter-widgets-script"
const TWITTER_THEME = "dark"

function normalizeTweetUrl(rawUrl) {
  try {
    const url = new URL(rawUrl)
    const host = url.hostname.toLowerCase()
    const allowedHosts = new Set([
      "x.com",
      "www.x.com",
      "twitter.com",
      "www.twitter.com",
      "mobile.twitter.com",
    ])

    if (!allowedHosts.has(host)) return null

    const match = url.pathname.match(/^\/([A-Za-z0-9_]{1,15})\/status\/(\d+)/)
    if (!match) return null

    const [, username, tweetId] = match
    return `https://twitter.com/${username}/status/${tweetId}`
  } catch {
    return null
  }
}

function loadTwitterWidgetsScript() {
  const existing = document.getElementById(TWITTER_SCRIPT_ID)
  if (existing) return existing

  const script = document.createElement("script")
  script.id = TWITTER_SCRIPT_ID
  script.async = true
  script.src = TWITTER_WIDGETS_SRC
  document.head.appendChild(script)
  return script
}

function getStandaloneUrlFromParagraph(paragraph) {
  if (!paragraph || paragraph.tagName !== "P") return null

  if (paragraph.childElementCount === 0) {
    const text = paragraph.textContent.trim()
    return /^https?:\/\/\S+$/.test(text) ? text : null
  }

  if (paragraph.childElementCount === 1 && paragraph.firstElementChild?.tagName === "A") {
    const anchor = paragraph.firstElementChild
    const paragraphText = paragraph.textContent.trim()
    const anchorText = anchor.textContent.trim()
    if (paragraphText !== anchorText) return null
    return anchor.getAttribute("href")
  }

  return null
}

function embedStandaloneTweetLinks() {
  const paragraphs = document.querySelectorAll(".prose p")
  const tweetBlocks = []

  for (const paragraph of paragraphs) {
    const rawUrl = getStandaloneUrlFromParagraph(paragraph)
    if (!rawUrl) continue

    const tweetUrl = normalizeTweetUrl(rawUrl)
    if (!tweetUrl) continue

    const blockquote = document.createElement("blockquote")
    blockquote.className = "twitter-tweet"
    blockquote.setAttribute("data-dnt", "true")
    blockquote.setAttribute("data-theme", TWITTER_THEME)

    const anchor = document.createElement("a")
    anchor.href = tweetUrl
    anchor.textContent = tweetUrl
    blockquote.appendChild(anchor)

    paragraph.replaceWith(blockquote)
    tweetBlocks.push(blockquote)
  }

  if (tweetBlocks.length === 0) return

  if (window.twttr?.widgets?.load) {
    window.twttr.widgets.load()
    return
  }

  const script = loadTwitterWidgetsScript()
  script.addEventListener(
    "load",
    () => {
      if (window.twttr?.widgets?.load) window.twttr.widgets.load()
    },
    { once: true }
  )
}

document.addEventListener("DOMContentLoaded", () => {
  embedStandaloneTweetLinks()
})

console.info("Bridgetown is loaded!")
